interface Props {
  currentStep: 1 | 2 | 3
}

const steps = [
  { id: '01', name: 'INTRO VIDEO' },
  { id: '02', name: 'PORTFOLIO' },
  { id: '03', name: 'REVIEW' },
]

const ReapplySteps = ({ currentStep }: Props) => {
  const currentIdx = currentStep - 1

  return (
    <nav aria-label='progress' className='mt-4'>
      <ol className='flex space-y-0 space-x-4 md:space-x-8'>
        {steps.map((step, stepIdx) => (
          <li key={step.id} className='flex-1'>
            {stepIdx < currentIdx ? (
              <div
                className='flex flex-col h-2 rounded-full bg-gray-800'
                aria-current='step'
              />
            ) : stepIdx === currentIdx ? (
              <div className='overflow-hidden rounded-full bg-gray-200'>
                <div
                  className='flex flex-col h-2 rounded-full bg-gray-800'
                  style={{ width: '50%' }}
                />
              </div>
            ) : (
              <div className='h-2 rounded-full bg-gray-200' />
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export { ReapplySteps }
